import { useCallback, useEffect, useState } from 'react';
import { clamp } from '../utils/clamp';
export function useOffsetCalc({ contentRef, containerRef, ratio, min, max }) {
    /**
     * BE AWARE that when selected value growths - offset is smaller (moving towards right means having smaller and smaller position offset).
     *
     * So the min* values are with big offsets.
     * While the max* values are with small (often negative) offsets.
     */
    const [minScaleOffset, setMinScaleOffset] = useState(0);
    const [minUserOffset, setMinUserOffset] = useState(0);
    const [maxScaleOffset, setMaxScaleOffset] = useState(0);
    const [maxUserOffset, setMaxUserOffset] = useState(0);
    const [boundsInitialized, setBoundsInitialized] = useState(false);
    const calcOffsetWithRatio = useCallback((ratioedValue) => {
        let newOffset = 0;
        if (containerRef && containerRef.current) {
            newOffset = containerRef.current.clientWidth / 2 - Math.floor(ratioedValue * ratio) - 1;
        }
        if (boundsInitialized) {
            return clamp(newOffset, maxUserOffset, minUserOffset);
        }
        else {
            return newOffset;
        }
    }, [containerRef, ratio, minUserOffset, maxUserOffset, boundsInitialized]);
    useEffect(() => {
        if (contentRef && containerRef && contentRef.current && containerRef.current) {
            const minScaleOffset = containerRef.current.clientWidth / 2;
            const minUserOffset = min === undefined ? minScaleOffset : calcOffsetWithRatio(min);
            setMinScaleOffset(minScaleOffset);
            setMinUserOffset(minUserOffset);
            const maxScaleOffset = contentRef.current.offsetWidth * -1 + containerRef.current.clientWidth / 2;
            const maxScaleUser = max === undefined ? maxScaleOffset : calcOffsetWithRatio(max);
            setMaxScaleOffset(maxScaleOffset);
            setMaxUserOffset(maxScaleUser);
            setBoundsInitialized(true);
        }
    }, [contentRef, containerRef, ratio, min, max, calcOffsetWithRatio]);
    return { minScaleOffset, minUserOffset, maxScaleOffset, maxUserOffset, calcOffsetWithRatio };
}
